var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500977,
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1940_3904",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1940_3904",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEAUlEQVR4nO2aSWgUQRSGI+jVk8sxXUlUcEMQNxQXEBREzwp696CgCSiomJvLxQWnXhxNICqKGDExHsQYlxzUg7t4MMHEDVRcoqmayUySkZJqEHXMhJ52xlf2/D/8l2l4/eb/uraZLiuDIAiCIAiCIAiCICgCqiA9XUhdLUgdEqTjsI77WUhdXRnT0/4liAke6VZB2sA6dwZSX7RZFR2GIN0NEDrQw+hJ/bzqsBpfNCAYGTrMrNBcvDUD05QJk0FR1hRBugZAdLh1M6a3Fh6IVAcBRIcC4pE6UHAgnlQxANHhgEgVAxByZ1sOIMQPAUCIP3gAIf6wAYT4AwYQ4g8VQIg/SAAh/vAAxIHABIDwhyQAhD8YASD8YQgHjJ9OiB8CgBB/8ABC/GEDCPEHDCDEHyqAEH+QAEL84ZUkkPmNCbOlPWV2dqTNupakqawLX2vF2aTZfiPle+XZZOg6VXXa78X2tLU9ZeadSJQGkG3XU+bF12/mjfrp9pdDZk5jfgFUHdWm4fHgb3Wsjz8a9K/lU2tuY8Lv4dc6tsea9lS0gdgn8HVWgD98uXvQVORRa/+d9LB1rPfdSQeuY+95pedPsNa217UtyegCae78/SnM9upz/YHqTI5r09WbyVmnszdjJgUcJWua+kfs6ULnUHSBPHiXO0TrTW3BpohFp5Ij1rFeeDLYk725LTViHdtzZIFcz5qns72+NdgImVmfMK/6ctex12bUB1uTNlwaeYTYtSWyQHZ15J73n3zImKnHgi/s55/lhtv0LHiI9p5PP+YeuTtupqMLxM7rLcOsI91fvvkLvsij1oITCXN/mCnw3vuMv63Op5a9t+0hu1Zz11Dgtei/BGJtt6TV11I+mKsvhszRBwNm6elwO5lZDQmz93ba36FZ77mV9j8LU2vZmaSJPxzwe7KbD3tOynf7/F8CKUV7AKLZIQAI8QcPIMQfNoAQf8AAQvyhAgjxBwkgxB8egDgQmAAQ/pAEgPAHIwCEPwzhgPHTCfFDABDiDx5AiD9sACH+gAGE+EMFEOIPEkCIPzwAcSAwASAlB+QIXnIgp4DsBhByyssBhBwZHaQ7l9Sa0QBCDsCQatCLqcUFh4EX5XQYIF8qZN+qosAoNBBP6q+CdG/kLNVbIfVtj1Tt5LgaVzQYBQayr8yYUUVtthT010CkypRLtZH7e0RGfwVEqqSQfau5v0OkFBqI1J8r6tRC7v4jp5BAejzqm8LdeySVLxBPqrviuJ7I3XdklQ8Qj9TVqsOfxnL3HGkFBiJV4+y4GcPdb+QVEAjOGE4AwRnDISA4YzgEBGcMp4DgjOEKEJwxHAKCM4ZLQHDGcEflscQs/I8BQRAEQRAEQRAEQVBZSek70b1M9BzWEhsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatB);
export default __webpack_public_path__ + "static/media/ChatB.8fec58117226efa1a89409a522fd29b0.svg";
export { ForwardRef as ReactComponent };